export default {
  newWindow: 'Öppnas i nytt fönster',
}
